import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormLabel from '@material-ui/core/FormLabel';
import GridItem from 'components/Grid/GridItem.jsx';
import ImageUpload from 'components/CustomUpload/ImageUpload.jsx';
import { Info } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import gastro from 'helpers/gastro';
import ImageUploadWithProportions from 'components/CustomUpload/ImageUploadWithProportions';
import { makeStyles } from '@material-ui/styles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';

const useStyles = makeStyles({
  labelHorizontal: extendedFormsStyle.labelHorizontal,
});

const FormImageUpload = ({
  label,
  getImage,
  removeImage,
  stateName,
  previewUrl,
  buttonText,
  labelAdditionalContent,
  imgId,
  tooltipImageSize,
  defaultImage = null,
  isDisabled = false,
  maxFileSize,
  proportionsConstraint,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [imageDimension, setImageDimension] = useState('');

  const uploadImage = async (state, image) => {
    const data = new FormData();
    data.append('file', image);

    const response = await gastro.post('/media', data);

    getImage(state, response.data);
  };

  const ImageUploadComponent = proportionsConstraint
    ? ImageUploadWithProportions
    : ImageUpload;

  return (
    <React.Fragment>
      {imgId && tooltipImageSize && (
        <Tooltip
          onOpen={() => {
            const img = document.getElementById(imgId);
            if (img !== null) {
              const { naturalHeight, naturalWidth } = img;
              const imgSizeDescription = `${naturalWidth}px na ${naturalHeight}px`;
              setImageDimension(imgSizeDescription);
            }
          }}
          style={{ marginLeft: '10px', color: 'grey' }}
          title={
            <>
              <p>
                {t('form.menuPlanning.actualPictureSize')}: {imageDimension}
              </p>
              {t('form.menuPlanning.recommendedPictureSize')}:{' '}
              {tooltipImageSize}
            </>
          }
        >
          <Info fontSize="small" />
        </Tooltip>
      )}
      {label && (
        <GridItem xs={12}>
          <div
            style={{
              marginLeft: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FormLabel className={classes.labelHorizontal}>{label}</FormLabel>
            {labelAdditionalContent}
          </div>
        </GridItem>
      )}
      <GridItem xs={12}>
        <ImageUploadComponent
          stateName={stateName}
          getImage={uploadImage}
          removeImage={removeImage}
          previewUrl={
            previewUrl
              ? process.env.REACT_APP_STATIC_FILES_CDN + previewUrl
              : null
          }
          buttonText={buttonText}
          imgId={imgId}
          addButtonProps={{
            color: 'info',
            round: false,
          }}
          changeButtonProps={{
            color: 'info',
            round: false,
          }}
          removeButtonProps={{
            color: 'danger',
            round: false,
          }}
          defaultImage={defaultImage}
          isDisabled={isDisabled}
          maxFileSize={maxFileSize}
          proportionsConstraint={proportionsConstraint}
        />
      </GridItem>
    </React.Fragment>
  );
};

export default FormImageUpload;
